// removed by extract-text-webpack-plugin
module.exports = {"small":"(min-width:600px)","medium":"(min-width:768px)","medium-large":"(min-width:1024px)","large":"(min-width:1200px)","extra-large":"(min-width:1400px)","wide":"(min-width:1600px)","sansBold":"fonts__sansBold___1u-Eg","table":"archive__table___2Eln-","th":"archive__th___2-57f","td":"archive__td___2_0Vp","title":"archive__title___3cMg0 fonts__sansBold___1u-Eg"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Archive/archive.css
// module id = 152
// module chunks = 0